module.exports = __webpack_public_path__ + "static/img/我的陪护证@3x.903358b.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/我的陪护证@3x.png
// module id = 313
// module chunks = 379 380